// allowed types: text, multiline, date, bool, int, double, options (need key optiosn with key, value), fileupload

import AirConditioning from './air_conditioning'
import DcSystem from './dc_system'
import Battery from './battery'

const codeLists = {
  contact: {
    title: 'Contact',
    meta: [
      {
        key: 'first_name',
        label: 'First name',
        type: 'text',
      },
      {
        key: 'last_name',
        label: 'Last name',
        type: 'text',
      },
      {
        key: 'company',
        label: 'Company',
        type: 'text',
      },
      {
        key: 'active',
        label: 'Active',
        type: 'bool',
      },
      {
        key: 'job_title',
        label: 'Job title',
        type: 'text',
      },
      {
        key: 'role',
        label: 'Role',
        type: 'text',
      },
      {
        key: 'email_w',
        label: 'E-mail(w)',
        type: 'text',
      },
      {
        key: 'email_h',
        label: 'E-mail(h)',
        type: 'text',
      },
      {
        key: 'mobile_w',
        label: 'Mobile(w)',
        type: 'text',
      },
      {
        key: 'mobile_h',
        label: 'Mobile(h)',
        type: 'text',
      },
      {
        key: 'phone_w',
        label: 'Phone(h)',
        type: 'text',
      },
      {
        key: 'phone_h',
        label: 'Phone(h)',
        type: 'text',
      },
      {
        key: 'fax',
        label: 'Fax',
        type: 'text',
      },
      {
        key: 'address',
        label: 'Address',
        type: 'text',
      },
      {
        key: 'town',
        label: 'Town',
        type: 'text',
      },
      {
        key: 'country',
        label: 'Country',
        type: 'text',
      },
      {
        key: 'mb_company',
        label: 'MB company',
        type: 'text',
      },
      {
        key: 'oib',
        label: 'OIB',
        type: 'text',
      },
      {
        key: 'company_tax_number',
        label: 'Company tax number',
        type: 'text',
      },
      {
        key: 'jmbg',
        label: 'JMBG',
        type: 'text',
      },
      {
        key: 'comment',
        label: 'Comment',
        type: 'multiline',
      },
    ],
    permissions: {
      add: ['edit_contact'],
      edit: ['edit_contact'],
    },
  },
  air_conditioning_status: AirConditioning.status,
  air_conditioning_type: AirConditioning.type,
  battery_status: Battery.status,
  battery_type: Battery.type,
  battery_manufacturer: {
    title: 'Battery manufacturer',
    meta: [],
  },
  bilateral_trilateral: {
    title: 'Bilateral trilateral',
    meta: [],
  },
  construction_subtype: {
    title: 'Construction subtype',
    meta: [],
  },
  construction_type: {
    title: 'Construction type',
    meta: [],
  },
  cooling_subtype: {
    title: 'Cooling subtype',
    meta: [],
  },
  cooling_type: {
    title: 'Cooling type',
    meta: [],
  },
  cooling_unit_owner: {
    title: 'Cooling unit owner',
    meta: [],
  },
  coverage_type: {
    title: 'Coverage type',
    meta: [],
  },
  cw_subcontractor: {
    title: 'CW subcontractor',
    meta: [],
  },
  cw_supervisor: {
    title: 'CW supervisor',
    meta: [],
  },
  dc_system_status: DcSystem.status,
  dc_system_type: DcSystem.type,
  equipment_space_subtype: {
    title: 'Equipment space subtype',
    meta: [],
  },
  equipment_space_type: {
    title: 'Equipment space type',
    meta: [],
  },
  fance: {
    title: 'Fance',
    meta: [],
  },
  generator: {
    title: 'Generator',
    meta: [],
  },
  generator_permanent: {
    title: 'Generator permanent',
    meta: [],
  },
  generator_possibility: {
    title: 'Generator possibility',
    meta: [],
  },
  generator_backup: {
    title: 'Generator backup, by OIV',
    meta: [],
  },
  generator_socket: {
    title: 'Generator socket',
    meta: [],
  },
  installed_in: {
    title: 'Installed in',
    meta: [],
  },
  new_used: {
    title: 'New/Used',
    meta: [],
  },
  permit_status: {
    title: 'Permit status',
    meta: [],
  },
  radio_equipment_type: {
    title: 'Radio equipment type',
    meta: [],
  },
  responsible_person: {
    title: 'Responsible person',
    meta: [],
  },
  responsible_person_permit: {
    title: 'Responsible person, Permit',
    meta: [],
  },
  responsible_person_acqusition: {
    title: 'Responsible person, Acqusition',
    meta: [],
  },
  responsible_person_radio: {
    title: 'Responsible person, Radio',
    meta: [],
  },
  responsible_person_construction: {
    title: 'Responsible person, Construction',
    meta: [],
  },
  responsible_person_transmision: {
    title: 'Responsible person, Transmision',
    meta: [],
  },
  responsible_person_design: {
    title: 'Responsible person, Design',
    meta: [],
  },
  site_access_risk: {
    title: 'Site access risk',
    meta: [],
  },
  site_group: {
    title: 'Site group',
    meta: [],
  },
  site_investment_type: {
    title: 'Site investment type',
    meta: [],
  },
  tower_designer: {
    title: 'Tower designer',
    meta: [],
  },
  tower_manufacturer: {
    title: 'Tower manufacturer',
    meta: [],
  },
  type_permit: {
    title: 'Type permit',
    meta: [],
  },
  controlling: {
    title: 'Controlling',
    meta: [
      {
        key: 'first_name',
        label: 'First name',
        type: 'text',
      },
      {
        key: 'last_name',
        label: 'Last name',
        type: 'text',
      },
      {
        key: 'email',
        label: 'Email',
        type: 'text',
      },
    ],
  },
  town: {
    title: 'Town',
    meta: [
      {
        key: 'postal',
        label: 'Postal',
        type: 'text',
      },
    ],
  },
  design_type: {
    title: 'Design type',
    meta: [],
  },
  project: {
    title: 'Project',
    meta: [],
    permissions: {
      add: ['edit_project'],
      edit: ['edit_project'],
    },
  },
  tenant: {
    title: 'Tenant',
    meta: [],
  },
  site_infrastructure_owner: {
    title: 'Site Infrastructure owner',
    meta: [],
  },
  designer_company: {
    title: 'Designer company',
    meta: [],
  },
  agreement_type: {
    title: 'Agreement type',
    meta: [],
  },
  agreement_status: {
    title: 'Agreement status',
    meta: [],
  },
  connection_type: {
    title: 'Connection type',
    meta: [],
  },
  power_provider: {
    title: 'Power provider',
    meta: [],
  },
  energy_source: {
    title: 'Energy source',
    meta: [],
  },
  method_of_payment: {
    title: 'Method of payment',
    meta: [],
  },
  payment_schedule: {
    title: 'Payment schedule',
    meta: [],
  },
  distribution_area: {
    title: 'Distribution area',
    meta: [],
  },
  distribution_section: {
    title: 'Distribution section',
    meta: [],
  },
  address_type: {
    title: 'Address type',
    meta: [],
  },
  hub_site: {
    title: 'HUB site',
    meta: [],
  },
  hub_importance: {
    title: 'HUB importance',
    meta: [],
  },
  bandwith_capacity: {
    title: 'Bandwith Capacity',
    meta: [],
  },
  polarization: {
    title: 'Polarization',
    meta: [],
  },
  port_type: {
    title: 'Port type',
    meta: [],
  },
  service_capacity: {
    title: 'Service capacity',
    meta: [],
  },
  service_provider: {
    title: 'Service provider',
    meta: [],
  },
  card_type: {
    title: 'Card type',
    meta: [
      {
        key: 'description',
        label: 'Description',
        type: 'multiline',
      },
      {
        key: 'width',
        label: 'Width',
        type: 'double',
      },
    ],
  },
  equipment_type: {
    title: 'Equipment type',
    meta: [
      {
        key: 'description',
        label: 'Description',
        type: 'multiline',
      },
      {
        key: 'manufacturer',
        label: 'Manufacturer',
        type: 'text',
      },
      {
        key: 'slots_from',
        label: 'Slots from',
        type: 'int',
      },
      {
        key: 'slots_to',
        label: 'Slots to',
        type: 'int',
      },
    ],
  },
  contractual_period_type: {
    title: 'Contractual Period Type',
    meta: [],
  },
  status: {
    title: 'Status',
    meta: [],
  },
  fuses_manufacturer: {
    title: 'Fuses Manufacturer',
    meta: [],
  },
  ac_system_manufacturer: {
    title: 'AC system Manufacturer',
    meta: [],
  },
  dc_system_manufacturer: {
    title: 'DC system Manufacturer',
    meta: [],
  },
  sa_subcontractor: {
    title: 'SA Subcontractor',
    meta: [],
  },
  type_rent: {
    title: 'Type of rent',
    meta: [],
  },
  account_type: {
    title: 'Account type',
    meta: [],
  },
  antenna: {
    title: 'Antenna',
    meta: [],
  },
  pred_model: {
    title: 'PredModel',
    meta: [],
  },
  counterpart: {
    title: 'Counterpart',
    meta: [
      {
        key: 'oib_number',
        label: 'OIB number',
        type: 'text',
      },
      {
        key: 'account',
        label: 'Account',
        type: 'text',
      },
      {
        key: 'address',
        label: 'Address',
        type: 'text',
      },
      {
        key: 'postal_code',
        label: 'Postal code',
        type: 'text',
      },
      {
        key: 'city',
        label: 'City',
        type: 'text',
      },
      {
        key: 'phone',
        label: 'Phone',
        type: 'text',
      },
      {
        key: 'mobile',
        label: 'Mobile',
        type: 'text',
      },
      {
        key: 'email',
        label: 'Email',
        type: 'text',
      },
      {
        key: 'blank',
        label: 'Blank',
        type: 'blank',
      },
    ],
  },
}

export default {
  codeLists: codeLists,
}
